import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {hideNotificationAlert, removeNotificationAlert} from 'modules/notifications';

import NotificationAlerts from 'components/notifications/NotificationAlerts';

import {ONE_ELEMENT} from 'util/constants';

import 'style/containers/notifications/notification-alerts.scss';

/** Component to render an alert panel with all the alerts */
class NotificationAlertsContainer extends Component {

    static propTypes = {
        title:  PropTypes.string, // The text for the page title
        alerts: PropTypes.array // Array with all the alerts to show
    };

    /**
     * Set this to handlers
     */
    componentWillMount() {

        this.handleRemove = this.handleRemove.bind(this);
        this.handleHide = this.handleHide.bind(this);

    }

    /**
     * Change the page title when any alert is shown
     */
    componentWillReceiveProps(nextProps) {
        const {title, intl: {formatMessage}} = this.props;
        const {notifications, alerts} = nextProps;

        const unread = notifications.filter(item => !item.read);

        if (unread.length && alerts.length) {
            document.title = formatMessage({id: `title.page.${unread.length === ONE_ELEMENT ? 'alert' : 'alerts'}`}, {alerts: unread.length, title});
        } else {
            document.title = nextProps.title;
        }
    }

    /**
     * Remove the passed notification
     * @param {Object} notification The notification object to remove
     */
    handleRemove(notification) {
        const {dispatch} = this.props;

        dispatch(removeNotificationAlert(notification.id));
    }

    /**
     * Hide this notification from alert without removing from the bell
     * @param {Object} notification The notification to hide
     */
    handleHide(notification) {
        const {dispatch} = this.props;

        dispatch(hideNotificationAlert(notification.id));
    }

    render() {
        const {alerts} = this.props;

        return (
            <NotificationAlerts
                alerts={alerts}
                onHide={this.handleHide}
            />
        );
    }
}

const mapStateToProps = state => ({
    alerts:        state.notifications.alerts,
    notifications: state.notifications.notifications,
    title:         state.ui.title
});

export default injectIntl(connect(mapStateToProps)(NotificationAlertsContainer));



// WEBPACK FOOTER //
// ./src/containers/notifications/NotificationAlertsContainer.jsx